
<form class="mce-form-section">

    <div class="mce-form-field-group flex-col">

        <div class="flex-grow" [class.mce-form-field-disabled]="framesRx.isLoading()">
            <mat-form-field class="w-full">
                <mat-label>mcb type</mat-label>
                <mat-select [formField]="form().assemblyGuid">
                    @for (option of frames(); track option.value) {
                    <mat-option [value]="option.value">{{option.label}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>


        <div class="flex gap-4">
            <div class="flex-grow" [class.mce-form-field-disabled]="ratingsRx.isLoading() || form().autoRating().value()">
                <mat-form-field class="w-full">
                    <mat-label>mcb rating, A</mat-label>
                    <mat-select [formField]="form().rating">
                        @for (option of ratings(); track option.i) {
                        <mat-option [value]="option.i">{{option.i}}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            <div>
                <mat-slide-toggle [formField]="form().autoRating">Auto</mat-slide-toggle>
            </div>

        </div>

    </div>
</form>
